import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseFinalDocumentSchema = Yup.object({
  finalDocumentName: Yup.string().required(messages.MANDATORY_FIELD),
  finalDocumentFileNumber: Yup.string().required(messages.MANDATORY_FIELD),
  resolutionType: Yup.object().required(messages.MANDATORY_FIELD),
  finalDocumentAdmissionDate: Yup.date().required(messages.MANDATORY_FIELD),
});
